import * as React from 'react';
import * as styles from './styles.css';

interface IOfferDescriptionProps {
  description: string;
}

export const OfferDescription = ({ description }: IOfferDescriptionProps) => {
  return <div className={styles['description']}>{description}</div>;
};
